import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { Contact } from '@/modules/contact/models/Contact';
import { User } from '@/modules/user/models/User';

export class BookingLinkInvitee extends BaseModel {
  id?: number;
  bookingLinkId?: number;
  userId?: number | null;
  name?: string;
  email?: string;
  user?: User | null;

  constructor(model: Partial<BookingLinkInvitee> = {}) {
    super(model);

    this.id = model.id;
    this.bookingLinkId = model.bookingLinkId;
    this.userId = model.userId;
    this.name = model.name;
    this.email = model.email;
    this.user = User.mapModelOrNull(model.user);
  }

  toUser(): User {
    if (this.user) {
      return this.user;
    }

    return User.factory({
      email: this.email,
      contact: Contact.factory({ firstName: this.name })
    });
  }
}
